import styled, { keyframes } from 'styled-components';

export const ThumbList = styled.div.attrs({
  className: 'col-12 col-md-3 col-xl-2',
})`
  background: #495057;
  height: calc(100vh - 59px);
  display: flex;
  aside {
    display: flex;
    flex-direction: column;
    position: relative;
    flex-grow: 1;
    /* for Firefox */
    min-height: 0;

    header {
      h4,
      p {
        line-height: 1;
        color: #fff;
      }
      p {
        opacity: 0.8;
      }
    }

    section {
      flex-grow: 1;
      overflow-y: auto;
      /* for Firefox */
      min-height: 0;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .card {
      opacity: 0.6;
      border-width: 2px;
      min-width: 100%;
      min-height: 80px;

      .card-header {
        display: none;
      }

      &:hover,
      &.active {
        outline: 0;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        opacity: 1;
        cursor: pointer;
        border-color: blue;

        .card-header {
          display: block;
        }
      }
    }

    .card-no-result {
      color: #ebebeb;
    }

    .form-control {
      height: 40px;
    }

    .search-bar {
      position: relative;

      .button-clear {
        border: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        top: 50%;
        height: 25px;
        width: 25px;
        margin-top: -12px;
        background: #ebebeb;
        color: #000;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        font-size: 0.7rem;
        line-height: 25px;
        cursor: pointer;

        &:hover {
          background-color: #ccc;
        }
      }
    }
  }
`;

export const WrapperCanva = styled.div.attrs({
  className: 'col-12 col-md-5 col-xl-7',
})`
  height: calc(100vh - 59px);
  background: #ebebeb;
  display: flex;
  justify-content: ${({ isEditing }) => (isEditing ? 'flex-start' : 'center')};
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
  min-height: 0;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const bounce = keyframes`
    from,20%,53%,80%,to {
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transform: translate3d(0, 0, 0);
    }
    40%,43% {
        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
        transform: translate3d(0, -5px, 0);
    }
    70% {
        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
        transform: translate3d(0, -2px, 0);
    }
    90% {
        transform: translate3d(0, -1px, 0);
    }
`;

export const NoCoverMessage = styled.div`
  user-select: none;
  opacity: 0.6;
  text-align: center;
  color: #666;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 500px;

  h2 {
    margin-bottom: 40px;
    line-height: 1;
  }

  svg {
    font-size: 8rem;
    animation: ${bounce} 1.5s infinite ease 3s;
  }
`;

export const Canva = styled.div`
  margin-left: auto;
  margin-right: auto;
  background: #fff;
  max-width: 600px;
  position: relative;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;

  .utils {
    display: ${({ isSaving }) => (isSaving ? 'none' : 'flex')};
  }

  .ql-editor.ql-blank::before {
    font-size: 19px;
    line-height: 1;
  }

  .ql-toolbar,
  .ql-toolbar.ql-snow {
    border-style: dashed;
    display: ${({ isSaving }) => (isSaving ? 'none' : 'block')};
  }
  #editor {
    min-height: 100px;
    font-size: 1.2rem;
    background: transparent;
    border-color: ${({ isSaving }) => (isSaving ? 'transparent' : '#ccc')};
    border-style: dashed;
  }

  .header {
    position: relative;
    z-index: 10;
    width: 600px;
    margin-bottom: 10px;
    min-height: 240px;
    display: flex;

    #header-editor {
      width: 250px;
      z-index: 10;
      border: 1px dashed
        ${({ isSaving }) => (isSaving ? 'transparent' : '#ebebeb')};
      font-size: 1.45rem;
      color: #001730;
      font-weight: 700;
      margin-top: 265px;
      margin-left: 20px;
      .ql-editor {
        line-height: 1.12;
      }
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  section {
    margin: 0 20px;

    textarea {
      &,
      &:focus {
        outline: 0;
      }

      padding: 10px;
      width: 100%;
      resize: none;
      background: transparent;
      border: 1px dashed
        ${({ isSaving }) => (isSaving ? 'transparent' : '#ebebeb')};
      font-size: 1.2rem;
    }
  }
`;

export const WrapperAction = styled.div.attrs({
  className: 'col-12 col-md-4 col-xl-3',
})`
  padding-top: 20px;
  padding-bottom: 20px;
`;
